import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { CategoryID, SearchResult, type AdItem as AdItemType, GeoLevel } from '@sbt-web/network/types';
import { Button, Icon } from '@sbt-web/ui';
import { getGeoInclusionLabel, getGeoLevel, getLabelFromGeo } from '@sbt-web/utils';
import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { RootState } from '@/reducers/index';
import { updateSearch, type SearchState } from '@/reducers/search';
import { useSavedSearches } from '@/shared/helpers/SavedSearches';
import { adTypesLabelsMap } from '@/tools/search/values';
import { getAvailableFilters } from '@/tools/tracking/getAvailableFiltersHelper';
import { transformSearch } from '@/tools/tracking/transformer';
import { getDataLayer, getOrCreatePulse } from '@/tools/tracking/utils';
import { AdItem } from '../../Containers/AdItem';
import ZrpImage from '../ZrpImage';
import classes from './index.module.scss';
type DispatchProps = {
  goToExtendedSearch: (extendedSearch: SearchState) => void;
};
type OwnProps = {
  extendedSearch: SearchState;
  extendedSearchData: SearchResult;
  listingCategoryId: CategoryID;
};
type StateProps = {
  search: SearchState;
  filtersConfig: FiltersConfigState;
};
type Props = OwnProps & StateProps & DispatchProps;
export const ZrpExtendedSearchComponent = t0 => {
  const $ = _c(63);
  const {
    extendedSearch,
    extendedSearchData,
    listingCategoryId,
    search,
    filtersConfig,
    goToExtendedSearch
  } = t0;
  const savedSearchesProvider = useSavedSearches();
  const {
    query,
    category,
    adType,
    geo,
    searchNearRegions
  } = search;
  let t1;
  if ($[0] !== adType) {
    t1 = adTypesLabelsMap[adType]?.toLowerCase();
    $[0] = adType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const adTypeLabel = t1;
  let t2;
  if ($[2] !== geo || $[3] !== searchNearRegions) {
    t2 = getLabelFromGeo(geo, searchNearRegions);
    $[2] = geo;
    $[3] = searchNearRegions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const geoLabel = t2;
  const geoLevel = getGeoLevel(geo, searchNearRegions);
  const expandedSearchCount = extendedSearchData.ads.length;
  let t3;
  if ($[5] !== extendedSearch || $[6] !== goToExtendedSearch || $[7] !== search.id) {
    t3 = () => {
      trackVediTutti(search.id);
      goToExtendedSearch(extendedSearch);
    };
    $[5] = extendedSearch;
    $[6] = goToExtendedSearch;
    $[7] = search.id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleVediTutti = t3;
  let t4;
  if ($[9] !== filtersConfig || $[10] !== savedSearchesProvider || $[11] !== search) {
    t4 = () => {
      savedSearchesProvider.saveSearch(search, filtersConfig);
    };
    $[9] = filtersConfig;
    $[10] = savedSearchesProvider;
    $[11] = search;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleAvvisami = t4;
  let t5;
  let t6;
  if ($[13] !== extendedSearch || $[14] !== extendedSearchData.ads || $[15] !== filtersConfig) {
    t5 = () => {
      trackDisplayedAds(extendedSearch, filtersConfig, extendedSearchData.ads);
    };
    t6 = [extendedSearch, filtersConfig, extendedSearchData.ads];
    $[13] = extendedSearch;
    $[14] = extendedSearchData.ads;
    $[15] = filtersConfig;
    $[16] = t5;
    $[17] = t6;
  } else {
    t5 = $[16];
    t6 = $[17];
  }
  useEffect(t5, t6);
  const t7 = classes;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ZrpImage className={classes.illustration} />;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = classes;
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h6 className="headline-6">Nessun risultato al momento...</h6>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = classes;
  let t12;
  if ($[20] !== query) {
    t12 = query && <><span className="body-text small">Stai cercando </span><span className="caption">{query} </span><span className="body-text small">in </span></>;
    $[20] = query;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = `${category.label} ${adTypeLabel} `;
  let t14;
  if ($[22] !== t13) {
    t14 = <span className="caption">{t13}</span>;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = "body-text small";
  const t16 = getGeoInclusionLabel(geoLevel ?? GeoLevel.Italia);
  let t17;
  if ($[24] !== t16) {
    t17 = <span className={t15}>{t16}</span>;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = ` ${geoLabel}`;
  let t19;
  if ($[26] !== t18) {
    t19 = <span className="caption">{t18}</span>;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t11.message || $[29] !== t12 || $[30] !== t14 || $[31] !== t17 || $[32] !== t19) {
    t20 = <div className={t11.message}>{t12}{t14}{t17}{t19}.</div>;
    $[28] = t11.message;
    $[29] = t12;
    $[30] = t14;
    $[31] = t17;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Icon name="Bell" />;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== handleAvvisami) {
    t22 = <Button type="button" icon={t21} onClick={handleAvvisami}>Avvisami</Button>;
    $[35] = handleAvvisami;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t10 || $[38] !== t20 || $[39] !== t22 || $[40] !== t9.content) {
    t23 = <div className={t9.content}>{t10}{t20}{t22}</div>;
    $[37] = t10;
    $[38] = t20;
    $[39] = t22;
    $[40] = t9.content;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t23 || $[43] !== t7.container || $[44] !== t8) {
    t24 = <div className={t7.container}>{t8}{t23}</div>;
    $[42] = t23;
    $[43] = t7.container;
    $[44] = t8;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  const t25 = expandedSearchCount === 1 ? "o " : "i ";
  let t26;
  if ($[46] !== expandedSearchCount || $[47] !== t25) {
    t26 = <section className={`caption ${classes.count}`}>{expandedSearchCount} risultat{t25}in Tutta Italia</section>;
    $[46] = expandedSearchCount;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== extendedSearchData.ads || $[50] !== listingCategoryId) {
    let t28;
    if ($[52] !== listingCategoryId) {
      t28 = (item, index) => <AdItem key={item.urn} item={item} index={index} listingCategory={listingCategoryId} />;
      $[52] = listingCategoryId;
      $[53] = t28;
    } else {
      t28 = $[53];
    }
    t27 = extendedSearchData.ads.map(t28);
    $[49] = extendedSearchData.ads;
    $[50] = listingCategoryId;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[54] !== t27) {
    t28 = <section>{t27}</section>;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== handleVediTutti) {
    t29 = <section className={classes.cta}><Button type="button" size="large" onClick={handleVediTutti}>Vedi tutti gli annunci</Button></section>;
    $[56] = handleVediTutti;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t24 || $[59] !== t26 || $[60] !== t28 || $[61] !== t29) {
    t30 = <>{t24}{t26}{t28}{t29}</>;
    $[58] = t24;
    $[59] = t26;
    $[60] = t28;
    $[61] = t29;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  return t30;
};
export default connect<StateProps, DispatchProps, OwnProps, RootState>(state => ({
  search: state.search,
  filtersConfig: state.filtersConfig
}), dispatch => ({
  goToExtendedSearch: (extendedSearch: SearchState) => {
    dispatch(updateSearch(extendedSearch));
  }
}))(ZrpExtendedSearchComponent);
function trackVediTutti(listingId?: string | null) {
  getOrCreatePulse()?.queueEvent({
    type: 'Engagement',
    object: {
      id: 'expand_all_ads_button_search_without_geo',
      type: 'UIElement',
      name: 'Vedi Tutti ZRP'
    },
    search: {
      '@id': listingId
    },
    target: {
      id: listingId,
      type: 'Listing'
    }
  });
}
function trackDisplayedAds(searchState: SearchState, filtersConfigState: FiltersConfigState, ads: AdItemType[]) {
  const {
    id: searchId,
    filterOrigin
  } = searchState;
  if (!searchId) return;
  const rawData = getDataLayer();
  const availableFilters = getAvailableFilters(searchState, filtersConfigState, rawData.search, ads.length);
  const searchMetadata = transformSearch(searchState, ads, searchId, filterOrigin, availableFilters);
  getOrCreatePulse()?.queueEvent({
    type: 'Recommend',
    object: {
      id: 'zrp_search_without_geo',
      type: 'Listing'
    },
    search: {
      ...searchMetadata,
      queryOrigin: 'Suggested'
    }
  });
}